import { Box, IconButton, Tab, Tabs, useTheme } from '@mui/material';
import { SyntheticEvent } from 'react';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
  tabs: string[];
  tabValue: number;
  wrapperSx?: object;
  handleChangeTabs: (event: SyntheticEvent, newValue: number) => void;
  handleRemoveTab?: (index: number) => void;
  disableClose?: boolean;
};

export const TabControls = ({ tabs, tabValue, wrapperSx, handleChangeTabs, handleRemoveTab, disableClose = true}: Props) => {
  const theme = useTheme();

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', margin: '0 0 8px 0', ...wrapperSx }}>
      <Tabs
        value={tabValue}
        onChange={handleChangeTabs}
        aria-label="contract tabs"
        textColor="inherit"
        variant="scrollable"
        sx={{
          '& .MuiTabs-indicator': { backgroundColor: theme.palette.customColors.emerald },
          '& .Mui-selected': { color: theme.palette.customColors.emerald },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab 
            key={index} 
            id={`tab-${index}`} 
            aria-controls={`tab-${index}`} 
            label={
              <Box sx={{display: 'flex', alignItems: 'center'}}>
                {tab}
                {(!disableClose && handleRemoveTab) &&
                  <IconButton
                    size='small'
                    onClick={(event) => {
                      event.stopPropagation();
                      handleRemoveTab!(index);
                    }}
                    disabled={disableClose}
                    >
                    <CloseIcon sx={{ fontSize: 14}}/>
                  </IconButton>
                }
              </Box>
            }
          />
        ))}
      </Tabs>
    </Box>
  );
};
